import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { GoalIcon } from './GoalIcon';
import { GoalName } from './GoalName';

export class GoalsFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [GoalIcon, GoalName];
  }

  get title() {
    return terminology('Goals');
  }
}
